import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=bbb45ed6&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=bbb45ed6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb45ed6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbb45ed6')) {
      api.createRecord('bbb45ed6', component.options)
    } else {
      api.reload('bbb45ed6', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=bbb45ed6&scoped=true", function () {
      api.rerender('bbb45ed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/five/instrument/Main.vue"
export default component.exports